import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { AnyCnameRecord } from 'dns';
import { CentroService } from 'src/app/services/centro.service';
import { DocAdicionalService } from 'src/app/services/doc-adicional.service';
import { DocumentoService } from 'src/app/services/documento.service';
import { EmailService } from 'src/app/services/email.service';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { CAUSAS_NOTIFICACION } from './../../../../constants/constants';


@Component({
  selector: 'app-validacion-adicional',
  templateUrl: './validacion-adicional.component.html',
  styleUrls: ['./validacion-adicional.component.scss']
})
export class ValidacionAdicionalComponent implements OnInit {

  causasNotificacion:any
  path:any
  notificaciones:any
  documento:any
  url:any
  comentarios3:any
  comentarios:any
  centro:any
  idUserDoc:any
  numArchivo:any
  newComentario:any
  comentariosCentro1:any
  comentariosCentro2:any
  comentariosCentro3:any
  comentariosCentro4:any
  tipo:any
  data:any
  dataDoc:any
  observaciones:any
  idPadre:any
  idAnterior:any
  tipoPadre:any

  constructor(@Inject(MAT_DIALOG_DATA) public info: {
    id: string,
    refresh: any
  }, 
  private formBuilder: FormBuilder, private apollo: Apollo, 
  private docAdicService: DocAdicionalService, private router: Router, 
  private centroService: CentroService, private usuarioService: UsuariosService, private emailService:EmailService,
  private documentoServicio: DocumentoService) {
    this.causasNotificacion = CAUSAS_NOTIFICACION
    this.path = this.router.url
  
  }

  ngOnInit(): void {
    this.getDocumentoById()
    this.buildForm()
  
  }

  private buildForm(){
    this.notificaciones = this.formBuilder.group({
      causa: ['', [Validators.required]],
      comentario: ['',[Validators.required]],
    });
  }

  getDocumentoById(){
    this.apollo.watchQuery<any>({
      query: this.docAdicService.getDocumentoById(),
      variables: {
        "id": this.info.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
     console.log(data)
        this.documento = data.documentosAdicional
        this.url = this.documento?.url

        this.comentarios = Object.assign([], this.documento?.comentarios)
        this.centro = this.documento?.centros[0];
    
        this.numArchivo = this.documento?.numArchivo
        this.idUserDoc = this.documento.subidoPor;
      
         switch (this.numArchivo) {
          case 1:
            this.comentarios3 = Object.assign([], this.centro?.comentariosAdic1)
           
            break;
          case 2:
            this.comentarios3 = Object.assign([], this.centro?.comentariosAdic2)
            break;
          case 3:
            this.comentarios3 = Object.assign([], this.centro?.comentariosAdic3)
            break;
         
          default:

            break;
        } 
        
      })
  }

  //comentarios para documentos que no sean Seguridad social y hacienda
  addComentario(){
    this.newComentario = this.notificaciones.value
    this.newComentario.fecha = new Date()
    this.comentarios?.push(this.newComentario)
  } 
  updateComentarios() {
   
    if(this.centro){
      this.updateCentroComentarios()
    }
  }


  setEmptyInputs(){
    this.notificaciones.reset()
  }

 

  updateCentroComentarios(){

    console.log(this.centro);
    
  
    this.comentariosCentro1 = Object.assign([], this.centro?.comentariosAdic1)
    this.comentariosCentro2 = Object.assign([], this.centro?.comentariosAdic2)
    this.comentariosCentro3 = Object.assign([], this.centro?.comentariosAdic3)
  
    
     switch (this.numArchivo) {
           case 1:
             this.newComentario = this.notificaciones.value
             this.newComentario.fecha = new Date()
             this.comentariosCentro1?.push(this.newComentario)
             console.log(this.comentariosCentro1);
             
             break;
           case 2:
             this.newComentario = this.notificaciones.value
             this.newComentario.fecha = new Date()
             this.comentariosCentro2?.push(this.newComentario);
             console.log(this.comentariosCentro2);
          
             break;
              case 3:
             this.newComentario = this.notificaciones.value
             this.newComentario.fecha = new Date()
             this.comentariosCentro3?.push(this.newComentario);
             console.log(this.comentariosCentro3);
         
             break;  
                
           default:
             break;
         }
     this.apollo.mutate({
       mutation: this.centroService.updateCentro(),
       variables: {
         "input": {
           "where": {
             "id": this.centro.id
           },
           "data": {
             "comentariosAdic1": this.comentariosCentro1,
             "comentariosAdic2": this.comentariosCentro2,
             "comentariosAdic3": this.comentariosCentro3,
             
            
           }
         }    
       }
     })
       .subscribe(({data, errors}) => {
         console.log("EDITADO CENTRO", data, errors)
       }, (error) => {
         console.log('aaaaa',error)
       })
   }

  updateValidacionDocumentoById(){
   
    if (this.documento.tipo === "pendiente") {
      this.tipo= "activo"
    } 
    if (this.documento.fechaCaducidad <= this.documentoServicio.getActualDate()) {
      this.apollo.mutate({
        mutation: this.docAdicService.updateDocumentoById(),
        variables: {
          "input": {
            "where": {
              "id": this.documento.id
            },
            "data": {
              "validado": true,
              "tipo": this.tipo,
              "estado":"rojo",
              "fechaCheck": this.documentoServicio.getActualDate(),
              "caducado": true
            }
          }    
        }
      })
        .subscribe(({data, errors}) => {
          console.log("EDITADO", data)
          this.data= data
          this.idPadre = this.data.updateDocumentosAdicional.documentosAdicional.idPadre
          this.tipoPadre = this.data.updateDocumentosAdicional.documentosAdicional.tipo
          if (this.idPadre != null){
            this.updateDocumentoAnteriorById()
          } 
          setTimeout(() => {
            location.reload()
           }, 1200);
        }, (error) => {
          console.log('aaaaa',error)
        })
    }
    if (this.documento.fechaCaducidad > this.documentoServicio.getNextMonth() && this.documento.fechaCaducidad > this.documentoServicio.getActualDate()) {
      this.apollo.mutate({
        mutation: this.docAdicService.updateDocumentoById(),
        variables: {
          "input": {
            "where": {
              "id": this.documento.id
            },
            "data": {
              "validado": true,
              "tipo": this.tipo,
              "estado":"verde",
              "fechaCheck": this.documentoServicio.getActualDate(),
              "enFecha": true
            }
          }    
        }
      })
        .subscribe(({data, errors}) => {
          console.log("EDITADO", data)
          this.data= data
          this.idPadre = this.data.updateDocumentosAdicional.documentosAdicional.idPadre
          this.tipoPadre = this.data.updateDocumentosAdicional.documentosAdicional.tipo
          if (this.idPadre != null){
            this.updateDocumentoAnteriorById()
          } 
          setTimeout(() => {
            location.reload()
           }, 1200);
        }, (error) => {
          console.log('aaaaa',error)
        })
    } 

    if (this.documento.noCaduca == true) {
      this.apollo.mutate({
        mutation: this.docAdicService.updateDocumentoById(),
        variables: {
          "input": {
            "where": {
              "id": this.documento.id
            },
            "data": {
              "validado": true,
              "tipo": this.tipo,
              "estado":"verde",
              "fechaCheck": this.documentoServicio.getActualDate()
            }
          }    
        }
      })
        .subscribe(({data, errors}) => {
          console.log("EDITADO", data)
          this.data= data
          this.idPadre = this.data.updateDocumentosAdicional.documentosAdicional.idPadre
          this.tipoPadre = this.data.updateDocumentosAdicional.documentosAdicional.tipo
          if (this.idPadre != null){
            this.updateDocumentoAnteriorById()
          } 
          setTimeout(() => {
            location.reload()
           }, 1200);
        }, (error) => {
          console.log('aaaaa',error)
        })
    } 

    if (this.documento?.fechaCaducidad <= this.documentoServicio.getNextMonth() && this.documento?.fechaCaducidad > this.documentoServicio.getActualDate()) {
      this.apollo.mutate({
        mutation: this.docAdicService.updateDocumentoById(),
        variables: {
          "input": {
            "where": {
              "id": this.documento.id
            },
            "data": {
              "validado": true,
              "tipo": this.tipo,
              "estado":"amarillo",
              "fechaCheck": this.documentoServicio.getActualDate(),
              "proximoCaduca": true
            }
          }    
        }
      })
        .subscribe(({data, errors}) => {
          console.log("EDITADO", data)
          this.data= data
          this.idPadre = this.data.updateDocumentosAdicional.documentosAdicional.idPadre
          this.tipoPadre = this.data.updateDocumentosAdicional.documentosAdicional.tipo
          if (this.idPadre != null){
            this.updateDocumentoAnteriorById()
          } 
          setTimeout(() => {
            location.reload()
           }, 1200);
        }, (error) => {
          console.log('aaaaa',error)
        })
    }
    
  }
  
  
  //Para cambiar estado del documento anterior que va a reemplazar
  updateDocumentoAnteriorById(){
  
    if (this.tipoPadre === "pendiente" || this.tipoPadre === "activo") {
      this.tipo= "inactivo"
    }
    this.apollo.mutate({
      mutation: this.docAdicService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": this.idPadre
          },
          "data": {
            "validado": true,
            "tipo": this.tipo,
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data)
        setTimeout(() => {
            location.reload()
           }, 1000);
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

  //Documento no valido
  updateDocumentoNoValidadoById(){
   if (this.documento.tipo === "pendiente") {
      this.tipo= "noValido"
    } 
    this.apollo.mutate({
      mutation: this.docAdicService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": this.documento.id
          },
          "data": {
            "validado": false,
            "tipo":this.tipo
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data)
        this.data= data
        this.idAnterior = this.data.updateDocumentosAdicional.documentosAdicional.id
        this.idPadre = this.data.updateDocumentosAdicional.documentosAdicional.idPadre
        this.tipoPadre = this.data.updateDocumentosAdicional.documentosAdicional.tipo
        console.log(this.tipoPadre);
        console.log(data);
        
        
        if (this.idPadre != null){
          this.updateDocumentoAnteriorNoValidadoById()
        } 
        if ( this.tipoPadre === "noValido") {
           this.getUsuarioById(this.idUserDoc)
           setTimeout(() => {
            this.deleteDocumentoById(this.idAnterior)
           }, 3500);
           
        }
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

  getUsuarioById(id:any){
    this.apollo.watchQuery<any>({
      query: this.usuarioService.getUsuariosById(),
      variables: {
        id,
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        const mail = data.user.email
        const userName = data.user.username
       

        this.getDocumentoByIdDocRech(this.idAnterior)
        setTimeout(() => {
         
           if (this.dataDoc.centros != null) {
            this.getCentroById(this.dataDoc.centros[0].id);
            return
          }
          
        }, 2000);
        setTimeout(() => {
          console.log(this.observaciones)
          this.sendMail(userName, this.dataDoc.nombre, this.observaciones, mail, id)
        }, 3000);
        
        
      })
  }

  async sendMail(userName:any, nArchivo:any, observacion:any, mail:any, idUser:any){
    const templateDocRech = `
        <!DOCTYPE html>
        <html>
        <head>
        <title></title>
        </head>

        <body>
        <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/Problema_Documental_Xtensa_72a70b3570.png' style="width:500px; height:340px; display:block;
        margin:auto;">
        <div style="width:500px; margin:auto">
        
        <p>Estimado ${userName}</p>
        <p>Lamentamos comunicarle que la documentación que ha proporcionado por medio de la herramienta ha sido rechazada en el proceso de verificación.</p>
        <h5>Nombre del archivo</h5>
        <p>${nArchivo}</p>
        <h5>Observaciones:</h5>
        <p>${observacion}</p>
        </div>
        </body>

        </html>`;


           await this.emailService.send(
              mail,
              'Documento Rechazado',
              templateDocRech
            );
     this.updateUser('Lamentamos comunicarle que la documentación que ha proporcionado por medio de la herramienta ha sido rechazada en el proceso de verificación, se ha enviado un email a su bandeja de entrada con más información.', idUser)

  }
  updateUser(mensaje:any, id:any){
    this.apollo.mutate({
    mutation: this.usuarioService.updateUsuario(),
    variables: {
      "input": {
        "where": {
          "id": id
        },
        "data": {
          "mensaje": mensaje
        }
      }    
    }
  })
    .subscribe(({data, errors}) => {
     console.log(data);
     
    }, (error) => {
      /* console.log('aaaaa',error) */
    })
}

  //Para cambiar estado del documento anterior con la notificación de no aceptado
  updateDocumentoAnteriorNoValidadoById(){
     if (this.tipoPadre === "noValido") {
      this.tipo= "enEspera"
    }
    this.apollo.mutate({
      mutation: this.docAdicService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": this.idPadre
          },
          "data": {
            "tipo": this.tipo,
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO NUEVOOOO", data)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }
  //eliminar el registro que no es validado
   deleteDocumentoById(id: String){
    this.apollo.mutate({
      mutation: this.docAdicService.deleteDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
        }
      }
    })
      .subscribe(({data}) => {
        console.log('BORRADO', data)
      }, (error) => {
        console.log(error)
      })
  }

  updateComentarioDocumentoById(){
    this.addComentario()
    console.log(this.newComentario)
    console.log(this.comentarios)
    this.apollo.mutate({
      mutation: this.docAdicService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": this.info.id
          },
          "data": {
            "comentarios": this.comentarios,
            /* "comentariosNuevos": true, */
            "solicitudReemplazo": true
            
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data)
        this.setEmptyInputs()
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

  getDocumentoByIdDocRech(id:any){
    this.apollo.watchQuery<any>({
      query: this.docAdicService.getDocumentoById(),
      variables: {
        "id": id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        console.log(data)
        this.dataDoc = data.documentosAdicional
      
        
      })
  }

  getCentroById(id:any){  
    this.apollo.watchQuery<any>({
      query: this.centroService.getCentroById(),
      variables: {
        id: id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        console.log(data, 'datadoc', this.dataDoc);
        
        switch (this.dataDoc.numArchivo) {
          case 1:
            if (data.centro.comentariosAdic1.length == 0) {
              this.observaciones = data.centro.comentariosAdic1[0].comentario
            }else{
              this.observaciones = data.centro.comentariosAdic1[data.centro.comentariosAdic1.length-1].comentario
            }
            
            break;
          case 2:
            if (data.centro.comentariosAdic2.length == 0) {
              this.observaciones = data.centro.comentariosAdic2[0].comentario
            }else{
              this.observaciones = data.centro.comentariosAdic2[data.centro.comentariosAdic2.length-1].comentario
            }
            
            break;
          case 3:
            if (data.centro.comentariosAdic3.length == 0) {
              this.observaciones = data.centro.comentariosAdic3[0].comentario
            }else{
              this.observaciones = data.centro.comentariosAdic3[data.centro.comentariosAdic3length-1].comentario
            }
              
              break;
         
          default:
            break;
        }
      })
  }


}
